import React, {useEffect, useState} from "react"
import {useForm} from "react-hook-form";
import {Tabs} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';
import './vault.scss'
import Mastermind from "./vault-pages/Mastermind";
import Podcast from "./vault-pages/Podcast";
import SearchField from "../../../components/dashboard/search-field/SearchField";
import {VaultService} from "../../../services/vault-api.service";
import VaultFilterDropdown from "../../../components/common/filter-dropdown/VaultFilterDropdown";

export default function Vault() {
    const navigate = useNavigate();
    const [tagsData,setTagsData] = useState(false)
    const [options, setOptions] = useState([]);
    const [vaultFilters, setVaultFilters] = useState({});
    const location = useLocation();
    const {
        formState: {errors},
    } = useForm({
        mode: 'onChange',
    })

    const [activeTab, setActiveTab] = useState('1'); // Initial active tab key

    useEffect(() => {
        // Handle tab change when navigating back
        const params = new URLSearchParams(location.search);
        const tabFromQuery = params.get('activeTab');
        if (tabFromQuery) {
            setActiveTab(tabFromQuery);
        }
    }, [location.search]);

    async function GetVaultTags() {
        const response = await VaultService.getVaultTags()
        if (response.data?.data?.status){
            setTagsData(response?.data?.data?.data?.result.map((it,index)=> {
                return {
                    id: index +1,
                    name: it.allTags
                }
            }))

        }
    }



    useEffect(()=>{
        GetVaultTags()
    },[])

    const handleTabChange = (key) => {
        // Update the URL with the new active tab key
        const params = new URLSearchParams(location.search);
        params.set('activeTab', key);
        navigate(`?${params.toString()}`, { replace: true });

        // Update the state to reflect the active tab
        setActiveTab(key);
    };

    useEffect(() => {
        const settingOptions = [
            {
                label: (<span>Mastermind</span>),
                key: '1',
                children:<Mastermind filters={vaultFilters}/>,
            },
            {
                label: (<span>Podcast</span>),
                key: '2',
                children:<Podcast filters={vaultFilters}/>,
            },
            // {
            //     label:(<span>Onboarding</span>) ,
            //     key: '3',
            //     children:<Onboarding filters={vaultFilters}/>,
            // },
        ]

        setOptions(settingOptions)
    },[vaultFilters])

    const searchData= [
        {
            id:1,
            name: 'Tags',
            des: 'options'
        },
        {
            id:2,
            name: 'Tags',
            des: 'options'
        },
        {
            id:4,
            name: 'Tags',
            des: 'options'
        }
    ]

    return(
        <div className={'vault'}>
            <div className={'vault-section'}>
                <div className={'search-header mb-md-5 mb-3'}>
                    <SearchField searchData={tagsData} heading={'Tags'}/>
                    <VaultFilterDropdown onFilterChange={setVaultFilters} />
                </div>
                <div className={'vault-tabs'}>
                    <Tabs
                        defaultActiveKey="1"
                        tabPosition={'top'}
                        activeKey={activeTab}
                        onChange={handleTabChange}
                        items={options}
                    />
                </div>
            </div>
        </div>
    )
}